import { type AppErrorData } from '@/libs/logger/types/logger-types';

export default async function sendAppError(appErrorData: AppErrorData): Promise<boolean> {
  const response = await fetch(`${process.env.NEXT_PUBLIC_APP_URL}/react18/api/logger/app-error`, {
    body: JSON.stringify(appErrorData),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  });

  return response.ok;
}
